export interface IBranch {
  id: string; // Stable uuid referenced by working-hours blocks and appointments
  name: string;
  address?: string;
  phone?: string;
  locationImage?: string;
  active?: boolean;
}

// Client-supplied branch fields. `id` is server-generated; `locationImage` is
// always derived server-side from the address, never sent by the client.
export type IBranchInput = Omit<IBranch, 'id' | 'locationImage'> & { id?: string };

// The business's primary location. It is not stored in `branches[]`; this
// sentinel id represents it wherever a branch must be selected or tagged.
// Working-hours blocks with no `branchId` are treated as belonging to the main branch.
export const MAIN_BRANCH_ID = 'main';

